export * from 'notifications_config/constants/notifications_config_constants';



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/constants/index.js